var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaixar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 0C5.91421 0 6.25 0.335786 6.25 0.75V7.59717L9.00612 5.18557C9.31785 4.91281 9.79167 4.94439 10.0644 5.25612C10.3372 5.56785 10.3056 6.04167 9.99388 6.31443L5.99388 9.81443C5.71111 10.0619 5.28889 10.0619 5.00612 9.81443L1.00612 6.31443C0.694394 6.04167 0.662806 5.56785 0.935567 5.25612C1.20833 4.94439 1.68215 4.91281 1.99388 5.18557L4.75 7.59717V0.75C4.75 0.335786 5.08579 0 5.5 0ZM0.25 12.25C0.25 11.8358 0.585786 11.5 1 11.5H10C10.4142 11.5 10.75 11.8358 10.75 12.25C10.75 12.6642 10.4142 13 10 13H1C0.585786 13 0.25 12.6642 0.25 12.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaixar);
export default __webpack_public_path__ + "static/media/Baixar.eeb2330b5b4c7aef2b89bc929d9544d6.svg";
export { ForwardRef as ReactComponent };